<template>
  <div class="animated fadeIn">
    <div v-if="loading" class="text-center">
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <!-- <pre v-html="contentDetailBrechaOperacional"></pre> -->
    <b-card-body class="m-0 pt-0" id="areaImprimir">
      <b-row class="border-bottom mb-2" style="margin-right: 5px;">
        <b-col>
          <b-img
            :src="img"
            left
            fluid
            style="max-height: 100px"
            alt="Responsive image"
            class="rounded pb-0"
          ></b-img>
          <br />
          <h1 class="text-right">INFORME DE {{ process_type_name }}</h1>
          <p class="text-right">{{ process_date | moment }}</p>
          <a href="#" class="float-right text-black-50" @click="descargarPDF"
            ><i class="fa fa-download"></i
          ></a>
        </b-col>
      </b-row>
      <!-- <b-row class="mb-4">
        <b-col>
          <div>
            <strong>{{ company_details.company_name }}</strong>
          </div>
          <div>{{ company_details.company_number }}</div>
          <div>{{ company_details.address1 }}</div>
          <div>{{ company_details.address2 }}</div>
          <div>{{ company_details.contact_phone }}</div>
        </b-col>
      </b-row> -->
      <template v-if="contentDetailPT.length != 0">
        <h3></h3>
        <h6 class="mb-2 font-weight-bold"></h6>
        <div class="table-responsive-sm">
          <table class="table  table-sm">
            <thead>
              <tr class="font-weight-bold text-uppercase">
                <th class="text-center align-middle">
                  Orden <br />
                  Fabricación
                </th>
                <th class="text-left align-middle">
                  Código <br />
                  Producto
                </th>
                <th class="text-center">
                  Tipo<br />
                  Producto
                </th>
                <th class="text-center">Kilos PT</th>
                <th class="text-center">Lote</th>
                <th class="text-center">Recipiente</th>
                <th class="text-center">Cantidad</th>
                <th class="text-center">Kilos Teoricos<br />(Recp)</th>
                <th class="text-center">Kilos Real <br />(Recp)</th>
                <th
                  v-show="process_type_name == 'ENMALLADO'"
                  class="text-center"
                >
                  % Brecha<br />
                  Comercial
                </th>

                <th class="text-center">
                  MP
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(content, index) in contentDetailPT">
                <tr>
                  <td class="text-center align-middle">
                    {{ content.product__code.content__manufacturing_order }}
                  </td>
                  <td class="text-left align-middle">
                    {{ content.product__code.content__product__code }} <br />
                    {{ content.product__code.content__product__name }}
                  </td>

                  <td class="text-center">
                    {{
                      content.product__code.content__product__product_type__name
                    }}
                  </td>

                  <td class="text-center">
                    {{ content.product__code.sum_net_kilograms }}
                  </td>
                  <td class="text-center">
                    {{ content.product__code.content__lot__number }}
                  </td>
                  <td class="text-center">
                    {{ content.product__code.content__container__name }}
                  </td>
                  <td class="text-center">
                    {{ content.product__code.sum_quantity }}
                  </td>
                  <td class="text-center">
                    {{ content.product__code.theoretical_kilos }}
                  </td>
                  <td class="text-center">
                    {{ content.product__code.real_kilos }}
                  </td>
                  <td
                    class="text-center"
                    v-show="process_type_name == 'ENMALLADO'"
                  >
                    {{ content.product__code.trade_gap }}
                  </td>

                  <td class="text-center">
                    {{ content.product__code.content__product_reference__code }}
                    <br />
                    {{ content.product__code.content__product_reference__name }}
                    <br />
                    {{ content.product__code.MP }} Kgs
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </template>

      <template v-if="contentDetailMerma.length != 0">
        <h3>MERMA</h3>
        <h6 class="mb-2 font-weight-bold"></h6>
        <div class="table-responsive-sm">
          <table class="table  table-sm">
            <thead>
              <tr class="font-weight-bold text-uppercase">
                <th class="text-center align-middle">
                  Orden <br />
                  Fabricación
                </th>
                <th class="text-left align-middle">
                  Producto
                </th>
                <th class="text-center">Kilos PT</th>
                <th class="text-center">Lote</th>
                <th class="text-center">Recipiente</th>
                <th class="text-center">Cantidad</th>
                <th class="text-center">
                  Producto<br />
                  referencia
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(content, index) in contentDetailMerma">
                <tr>
                  <td class="text-center align-middle">
                    {{ content.product__code.content__manufacturing_order }}
                  </td>
                  <td class="text-left align-middle">
                    {{ content.product__code.content__product__name }}
                  </td>

                  <td class="text-center">
                    {{ content.product__code.sum_net_kilograms }}
                  </td>
                  <td class="text-center">
                    {{ content.product__code.content__lot__number }}
                  </td>
                  <td class="text-center">
                    {{ content.product__code.content__container__name }}
                  </td>
                  <td class="text-center">
                    {{ content.product__code.sum_quantity }}
                  </td>

                  <td class="text-center">
                    {{ content.product__code.content__product_reference__code }}
                    <br />
                    {{ content.product__code.content__product_reference__name }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </template>

      <template v-if="contentDetailDescarte.length != 0">
        <h3>DESCARTE</h3>
        <h6 class="mb-2 font-weight-bold"></h6>
        <div class="table-responsive-sm">
          <table class="table  table-sm">
            <thead>
              <tr class="font-weight-bold text-uppercase">
                <th class="text-center align-middle">
                  Orden <br />
                  Fabricación
                </th>
                <th class="text-left align-middle">
                  Producto
                </th>
                <th class="text-center">Kilos PT</th>
                <th class="text-center">Lote</th>
                <th class="text-center">Recipiente</th>
                <th class="text-center">Cantidad</th>

                <th class="text-center">
                  Producto<br />
                  referencia
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(content, index) in contentDetailDescarte">
                <tr>
                  <td class="text-center align-middle">
                    {{ content.product__code.content__manufacturing_order }}
                  </td>
                  <td class="text-left align-middle">
                    {{ content.product__code.content__product__code }} <br />
                    {{ content.product__code.content__product__name }}
                  </td>

                  <td class="text-center">
                    {{ content.product__code.sum_net_kilograms }}
                  </td>
                  <td class="text-center">
                    {{ content.product__code.content__lot__number }}
                  </td>
                  <td class="text-center">
                    {{ content.product__code.content__container__name }}
                  </td>

                  <td class="text-center">
                    {{ content.product__code.sum_quantity }}
                  </td>

                  <td class="text-center">
                    {{ content.product__code.content__product_reference__code }}
                    <br />
                    {{ content.product__code.content__product_reference__name }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </template>

      <template v-if="contentDetailBrechaComercial.length != 0">
        <h3>BRECHA COMERCIAL</h3>
        <h6 class="mb-2 font-weight-bold"></h6>
        <div class="table-responsive-sm">
          <table class="table  table-sm">
            <thead>
              <tr class="font-weight-bold text-uppercase">
                <th class="text-center align-middle">
                  Orden <br />
                  Fabricación
                </th>
                <th class="text-left align-middle">
                  Producto
                </th>
                <th class="text-center">Kilos PT</th>
                <th class="text-center">Lote</th>

                <th class="text-center">
                  Producto<br />
                  referencia
                </th>
              </tr>
            </thead>
            <tbody>
              <template
                v-for="(content, index) in contentDetailBrechaComercial"
              >
                <tr>
                  <td class="text-center align-middle">
                    {{ content.product__code.content__manufacturing_order }}
                  </td>
                  <td class="text-left align-middle">
                    {{ content.product__code.content__product__name }}
                  </td>

                  <td class="text-center">
                    {{ content.product__code.sum_net_kilograms }}
                  </td>
                  <td class="text-center">
                    {{ content.product__code.content__lot__number }}
                  </td>

                  <td class="text-center">
                    {{ content.product__code.content__product_reference__code }}
                    <br />
                    {{ content.product__code.content__product_reference__name }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </template>

      <template v-if="contentDetailBrechaOperacional.length != 0">
        <h3>BRECHA OPERACIONAL</h3>
        <h6 class="mb-2 font-weight-bold"></h6>
        <div class="table-responsive-sm">
          <table class="table  table-sm">
            <thead>
              <tr class="font-weight-bold text-uppercase">
                <th class="text-center align-middle">
                  Orden <br />
                  Fabricación
                </th>
                <th class="text-left align-middle">
                  Producto
                </th>
                <th class="text-center">Kilos PT</th>
                <th class="text-center">Lote</th>

                <th class="text-center">
                  Producto<br />
                  referencia
                </th>
              </tr>
            </thead>
            <tbody>
              <template
                v-for="(content, index) in contentDetailBrechaOperacional"
              >
                <tr>
                  <td class="text-center align-middle">
                    {{ content.product__code.content__manufacturing_order }}
                  </td>
                  <td class="text-left align-middle">
                    {{ content.product__code.content__product__name }}
                  </td>

                  <td class="text-center">
                    {{ content.product__code.sum_net_kilograms }}
                  </td>
                  <td class="text-center">
                    {{ content.product__code.content__lot__number }}
                  </td>

                  <td class="text-center">
                    {{ content.product__code.content__product_reference__code }}
                    <br />
                    {{ content.product__code.content__product_reference__name }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </template>

      <template v-if="contentDetailDevolution.length != 0">
        <h3>DEVOLUCIONES</h3>
        <h6 class="mb-2 font-weight-bold"></h6>
        <div class="table-responsive-sm">
          <table class="table  table-sm">
            <thead>
              <tr class="font-weight-bold text-uppercase">
                <th class="text-center align-middle">
                  Orden <br />
                  Fabricación
                </th>
                <th class="text-left align-middle">
                  Codigo<br />
                  Producto
                </th>
                <th class="text-center">Kilos PT</th>
                <th class="text-center">Lote</th>
                <th class="text-center">Recipiente</th>
                <th class="text-center">Cantidad</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(content, index) in contentDetailDevolution">
                <tr>
                  <td class="text-center align-middle">
                    {{ content.product__code.content__manufacturing_order }}
                  </td>
                  <td class="text-left align-middle">
                    {{ content.product__code.content__product__code }} <br />
                    {{ content.product__code.content__product__name }}
                  </td>

                  <td class="text-center">
                    {{ content.product__code.sum_net_kilograms }}
                  </td>
                  <td class="text-center">
                    {{ content.product__code.content__lot__number }}
                  </td>
                  <td class="text-center">
                    {{ content.product__code.content__container__name }}
                  </td>
                  <td class="text-center">
                    {{ content.product__code.sum_quantity }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </template>
      <h3>INGRESO A PROCESO</h3>
      <template v-if="contentDetailIn.length != 0">
        <h3></h3>
        <h6 class="mb-2 font-weight-bold"></h6>
        <div class="table-responsive-sm">
          <table class="table  table-sm">
            <thead>
              <tr class="font-weight-bold text-uppercase">
                <th class="text-left align-middle">
                  Código
                </th>
                <th class="text-left align-middle">
                  Producto
                </th>
                <th class="text-center">Lote</th>
                <th class="text-center">Tipo Producto</th>
                <th class="text-center">Kilos ingresados</th>
                <th class="text-center">Recipiente</th>
                <th class="text-center">Cantidad</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(content, index) in contentDetailIn">
                <tr>
                  <td class="text-left align-middle">
                    {{ content.product__code.content__product__code }}
                  </td>
                  <td>
                    {{ content.product__code.content__product__name }}
                  </td>
                  <td class="text-center">
                    {{ content.product__code.content__lot__number }}
                  </td>
                  <td class="text-center">
                    {{
                      content.product__code.content__product__product_type__name
                    }}
                  </td>
                  <td class="text-center">
                    {{ content.product__code.sum_net_kilograms }}
                  </td>
                  <td class="text-center">
                    {{ content.product__code.content__container__name }}
                  </td>
                  <td class="text-center">
                    {{ content.product__code.sum_quantity }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </template>
      <br />
      -
    </b-card-body>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import html2pdf from "html2pdf.js";
import moment from "moment";

export default {
  name: "ProcessReportDaily",
  props: {
    process_type: {
      type: String,
      default: ""
    },
    process_date: {
      type: String,
      default: ""
    },
    process_type_name: {
      type: String,
      default: ""
    }
  },
  created() {
    this.img = localStorage.getItem("img");
    this.client = this.$store.getters.user.ID_CLIENTE;
    //this.getProcess(this.process);
  },
  mounted() {
    this.onSubmit();
  },
  data() {
    return {
      loading: false,
      img: "",
      content_process: "",
      content_process_in: ""
    };
  },
  filters: {
    moment: function(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    num_format(value) {
      value = parseFloat(value);
      return numeral(value).format("0,0.00");
    }
  },
  watch: {
    "form.process_type": function(obj) {
      this.content_process = "";
    }
  },
  computed: {
    ...mapState({ company_details: state => state.user.DETAILS }),
    contentDetailPT() {
      if (this.content_process != "") {
        var result_filter = _(this.content_process)
          .filter(
            i =>
              i.content__product__product_type__name !== "DESCARTE" &&
              i.content__product__product_type__name !== "MERMA" &&
              i.content__product__product_type__name !== "BRECHA COMERCIAL" &&
              i.content__product__product_type__name !== "BRECHA OPERACIONAL" &&
              i.content__is_devolution === false
          )
          .value();

        const result_add_attributes = [];

        for (let key in result_filter) {
          const item = result_filter[key];

          let theoretical_kilos_content =
            parseFloat(result_filter[key].sum_net_kilograms) /
            parseFloat(result_filter[key].sum_quantity);

          let real_kilos =
            (parseFloat(result_filter[key].sum_net_kilograms) +
              parseFloat(
                this.getBrechaComercial(result_filter[key].content__lot__number)
              )) /
            parseFloat(result_filter[key].sum_quantity);

          let MP =
            parseFloat(real_kilos) *
            parseFloat(result_filter[key].sum_quantity);

          let trade_gap =
            (parseFloat(MP) -
              parseFloat(result_filter[key].sum_net_kilograms)) /
            parseFloat(result_filter[key].sum_net_kilograms);

          const returnedTarget = Object.assign(item, {
            theoretical_kilos: theoretical_kilos_content.toFixed(2),
            real_kilos: real_kilos.toFixed(2),
            MP: MP.toFixed(2),
            trade_gap: trade_gap.toFixed(2)
          });

          result_add_attributes.push(returnedTarget);
        }

        var result_group_by = _(result_add_attributes)
          // .groupBy(
          //   i => i.process__manufacturing_orde && i.content__product__code
          // )
          .map((value, key) => ({
            product_type: _.map(
              value,
              "content__product__product_type__name"
            )[0],
            product__code: value
          }))
          .value();

        return result_group_by;

        //return result_add_attributes;

        // var result_group_by = _(result_add_attributes)
        //   .groupBy(i => i.content__product__code)
        //   .map((value, key) => ({
        //     content__product__code: key,
        //     product_type: _.map(
        //       value,
        //       "content__product__product_type__name"
        //     )[0],
        //     product__code: value,
        //     theoretical_Kilos: Math.floor(Math.random() * 10 + 1)
        //   }))
        //   .value();

        // return result_group_by;
      }
    },
    contentDetailDevolution() {
      if (this.content_process != "") {
        var result = _(this.content_process)
          .filter(i => i.content__is_devolution === true)
          //.groupBy(i => i.content__product__code)
          .map((value, key) => ({
            //  content__product__code: key,
            product_type: _.map(
              value,
              "content__product__product_type__name"
            )[0],
            product__code: value
          }))
          .value();
        return result;
      } else {
        return [];
      }
    },
    contentDetailDescarte() {
      if (this.content_process != "") {
        var result = _(this.content_process)
          .filter(i => i.content__product__product_type__name === "DESCARTE")
          // .groupBy(i => i.content__product__code)
          .map((value, key) => ({
            product_type: _.map(
              value,
              "content__product__product_type__name"
            )[0],
            product__code: value
          }))
          .value();
        return result;
      } else {
        return [];
      }
    },
    contentDetailMerma() {
      if (this.content_process != "") {
        var result = _(this.content_process)
          .filter(i => i.content__product__product_type__name === "MERMA")
          //.groupBy(i => i.content__product__code)
          .map((value, key) => ({
            content__product__code: key,
            product_type: _.map(
              value,
              "content__product__product_type__name"
            )[0],
            product__code: value
          }))
          .value();
        return result;
      } else {
        return [];
      }
    },
    contentDetailBrechaComercial() {
      if (this.content_process != "") {
        var result = _(this.content_process)
          .filter(
            i => i.content__product__product_type__name === "BRECHA COMERCIAL"
          )
          //.groupBy(i => i.content__product_reference__code)
          .map((value, key) => ({
            product_type: _.map(
              value,
              "content__product__product_type__name"
            )[0],
            product__code: value
          }))
          .value();
        return result;
      } else {
        return [];
      }
    },
    contentDetailBrechaOperacional() {
      if (this.content_process != "") {
        var result = _(this.content_process)
          .filter(
            i => i.content__product__product_type__name === "BRECHA OPERACIONAL"
          )
          //.groupBy(i => i.content__product__code)
          .map((value, key) => ({
            product_type: _.map(
              value,
              "content__product__product_type__name"
            )[0],
            product__code: value
          }))
          .value();
        return result;
      } else {
        return [];
      }
    },
    contentDetailIn() {
      if (this.content_process != "") {
        var result_filter = _(this.content_process_in)
          .filter(
            i =>
              i.content__product__product_type__name !== "DESCARTE" &&
              i.content__product__product_type__name !== "MERMA" &&
              i.content__product__product_type__name !== "BRECHA COMERCIAL" &&
              i.content__product__product_type__name !== "BRECHA OPERACIONAL" &&
              i.content__is_devolution === false
          )
          .value();

        var result_group_by = _(result_filter)
          // .groupBy(
          //   i => i.content__product__code
          // )
          .map((value, key) => ({
            product_type: _.map(
              value,
              "content__product__product_type__name"
            )[0],
            product__code: value
          }))
          .value();

        return result_group_by;
      }
    }
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      this.content_process = "";
      const thisV = this;
      try {
        const response = await thisV.$axios.get("bagno/grouped-process/", {
          params: {
            date: thisV.process_date,
            process_type: thisV.process_type
          }
        });
        if (response.data != "") {
          thisV.content_process = response.data;
        } else {
          this.$toast.info(
            "No se encontro información segun parametros seleccionados.",
            ""
          );
        }
        thisV.loading = false;
      } catch (error) {
        console.log(error);
      }

      try {
        const response = await thisV.$axios.get("bagno/grouped-process-in/", {
          params: {
            date: thisV.process_date,
            process_type: thisV.process_type
          }
        });
        if (response.data != "") {
          thisV.content_process_in = response.data;
        } else {
          this.$toast.info(
            "No se encontro información segun parametros seleccionados.",
            ""
          );
        }
        thisV.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    descargarPDF() {
      const element = document.getElementById("areaImprimir").innerHTML;
      const opt = {
        margin: 0.25,
        image: { type: "jpeg", quality: 0.5 },
        filename: "Informe Proceso #213.pdf",
        // html2canvas: { dpi: 192, letterRendering: true },
        jsPDF: { unit: "in", format: "letter", orientation: "landscape" }
      };
      html2pdf(element, opt);
    },
    getBrechaComercial(lote) {
      //solo puede haber una brecha comercial por lote ?
      var result = _(this.content_process)
        .filter(
          i =>
            i.content__product__product_type__name === "BRECHA COMERCIAL" &&
            i.content__lot__number === lote
        )
        .value();

      if (Object.keys(result).length == 0) {
        return 0;
      } else {
        return result[0].sum_net_kilograms;
      }
    }
  }
};
</script>

<style scoped>
pre {
  outline: 1px solid #ccc;
  padding: 5px;
  margin: 5px;
}
.string {
  color: green;
}
.number {
  color: darkorange;
}
.boolean {
  color: blue;
}
.null {
  color: magenta;
}
.key {
  color: red;
}

.table-sm th,
.table-sm td {
  padding: 0.15rem;
}
</style>
